import { FormattedMessage, useIntl } from 'react-intl';

import { Button } from '@xing-com/button';
import { IconCross } from '@xing-com/icons';

import * as Styled from './follow-button.styles';

type FollowButtonProps = {
  isLoading: boolean;
  isFollowing: boolean;
  handleFollowClick: () => void;
  headline: string;
};

export const FollowButton: React.FC<FollowButtonProps> = ({
  isFollowing,
  isLoading,
  handleFollowClick,
  headline,
}) => {
  const intl = useIntl();
  const getAriaLabel = (actionType: 'FOLLOW' | 'UNFOLLOW'): string =>
    intl.formatMessage(
      { id: `NEWS_SOURCES_ARIA_LABEL_${actionType}` },
      { overviewPage: headline }
    );

  const ariaLabelFollow = getAriaLabel('FOLLOW');
  const ariaLabelUnfollow = getAriaLabel('UNFOLLOW');

  return isFollowing ? (
    <Styled.UnfollowButton
      icon={IconCross}
      size="medium"
      onClick={handleFollowClick}
      loading={isLoading}
      data-testid="follow-unfollow-button"
      aria-label={ariaLabelUnfollow}
    >
      <FormattedMessage id="FOLLOWING_RECOMMENDATION_PAGE_UNFOLLOW_BUTTON" />
    </Styled.UnfollowButton>
  ) : (
    <Button
      variant="secondary"
      onClick={handleFollowClick}
      loading={isLoading}
      data-testid="follow-unfollow-button"
      aria-label={ariaLabelFollow}
    >
      <FormattedMessage id="FOLLOWING_RECOMMENDATION_PAGE_FOLLOW_BUTTON" />
    </Button>
  );
};
